import { GET_PARTNER_DATA, GET_GUIDE_DATA, DELETE_GUIDE, ADD_GUIDE, GET_SINGLE_GUIDE, EDIT_GUIDE, EDIT_PARTNER, GET_SINGLE_PARTNER, SPOTLIGHT_PARTNER, SPOTLIGHT_GUIDE, DELETE_PARTNER } from "../actions/types"

const initialState = {
    data: [],
    guide: [],
    category: []
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PARTNER_DATA:
            return {
                ...state,
                data: action.payload
            };
        case GET_GUIDE_DATA:
            return {
                ...state,
                guide: action.payload
            }
        case DELETE_GUIDE:
            return {
                ...state,
            }
        case ADD_GUIDE:
            return {
                ...state,
                data: action.payload
            }
        case GET_SINGLE_GUIDE:
            return {
                ...state,
                category: action.payload
            }
        case EDIT_GUIDE:
            return {
                ...state,
            }
        case SPOTLIGHT_GUIDE:
            return {
                ...state
            }
        case DELETE_PARTNER:
            return {
                ...state
            }
        case SPOTLIGHT_PARTNER:
            return {
                ...state
            }
        case GET_SINGLE_PARTNER:
            return {
                ...state
            }
        case EDIT_PARTNER:
            return {
                ...state
            }    
        default:
            return state
    }
}